/**
 * @generated SignedSource<<900653dd0e6f0496e5946706c5adf363>>
 * @relayHash 2641b850d8a1aaeef736f82a4af6c167
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c44d6f4c0e964e4ae10eb3774e1cc1deecdf91a67926c17c3b9c7260ae7b62c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type MoreProjectsQuery$variables = {
  cloudId: string;
  currentURL?: AGG$URL | null | undefined;
};
export type MoreProjectsQuery$data = {
  readonly jira: {
    readonly canBrowseProjects: {
      readonly hasPermission: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira_projectsSidebarMenu: {
    readonly moreFavourites: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly projectKey: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly moreRecents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly projectKey: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoreProjectsQuery = {
  response: MoreProjectsQuery$data;
  variables: MoreProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentURL"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "alias": "canBrowseProjects",
      "args": [
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "BROWSE_PROJECTS"
        }
      ],
      "concreteType": "JiraPermission",
      "kind": "LinkedField",
      "name": "permission",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasPermission"
        }
      ]
    }
  ]
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "currentURL",
    "variableName": "currentURL"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v7 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
},
v9 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v10 = [
  {
    "concreteType": "JiraProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoreProjectsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v9/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoreProjectsQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_projectsSidebarMenu",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreFavourites",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          {
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "moreRecents",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "1c44d6f4c0e964e4ae10eb3774e1cc1deecdf91a67926c17c3b9c7260ae7b62c",
    "metadata": {},
    "name": "MoreProjectsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e26e837e2effa0504ef2d95ba6204e73";

export default node;
